import { createItemStorage } from "../../utils/createItemStorage";

export const billingInfo = ({ storage }) => createItemStorage(storage, "bi_v2");
